// ============================================================
// TimeSelect — selettore orario a 24 ore, brandizzato come la pagina
// prenotazioni del cliente (/prenotazioni usa <select class="input tnum">).
// Sostituisce <input type="time">, che mostrava il picker NATIVO del browser
// con am/pm: in Italia si usa l'orologio a 24 ore.
//
// Valore = stringa "HH:MM" (24h), identico a quello che dava l'input time, così
// è un drop-in nei form (drawer + nuova prenotazione).
// ============================================================

/** Passo dei minuti (lo standard nei sistemi di prenotazione). */
const STEP_MIN = 15;

/** Tutti gli slot "HH:MM" della giornata, ogni STEP_MIN minuti. */
const SLOTS: string[] = (() => {
  const out: string[] = [];
  for (let m = 0; m < 24 * 60; m += STEP_MIN) {
    const h = Math.floor(m / 60);
    const mm = m % 60;
    out.push(`${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`);
  }
  return out;
})();

export function TimeSelect({
  id,
  value,
  onChange,
}: {
  id?: string;
  value: string;
  onChange: (next: string) => void;
}) {
  // Se la prenotazione ha un orario fuori griglia (es. importata alle 14:47),
  // lo includiamo comunque così il valore non si perde quando si apre il form.
  const options = value && !SLOTS.includes(value) ? [value, ...SLOTS].sort() : SLOTS;
  return (
    <select id={id} className="input tnum" value={value} onChange={(e) => onChange(e.target.value)}>
      {!value && <option value="">—</option>}
      {options.map((s) => (
        <option key={s} value={s}>
          {s}
        </option>
      ))}
    </select>
  );
}
